module.exports = __webpack_public_path__ + "img/dm.dc34557.svg";